import { upperFirst } from 'lodash'

export const routeToEventRoute = (route: string) =>
  route
    .split(/\/|-/)
    .filter((breadcrumb) => !breadcrumb.includes(':'))
    .map((breadcrumb) => upperFirst(breadcrumb))
    .join(' ')
    .trim()
